<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage tarrif rates</small>
      </legend>
      <div></div>
      <div class="tarrifLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span style="font-size: 14px">loading tarrif...</span>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemTarrifs"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">
            <button class="btn btn-info btn-sm btn-rounded" @click="viewTarrif(props.row.id)">
              <i class="fa fa-edit" data-toggle="tooltip" title="Edit tarrif rate!"></i> Edit Tarrif
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Category",
          field: "tarrif_category",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by tarrif category"
          }
        },
        {
          label: "Item name",
          field: "item_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by item name"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadTarrif();
  },
  computed: {
    ...mapGetters(["systemTarrifs"])
  },
  methods: {
    ...mapActions(["loadTarrif", "viewTarrif"])
  }
};
</script>


// WEBPACK FOOTER //
// src/tarrifs/managetarrifs.vue